import * as React from "react";
import {DeleteButton, SaveButton, Toolbar} from 'react-admin';

const ActionsMod = ({title}) => {

    return (<h3 style={{
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontSize: '20px',
        lineHeight: '24px'
    }}>{title}</h3>);
};

export default ActionsMod;